<template>
  <div class="warn-section">
    <p>
      ** กรณีไม่เลือก แบรนและหมวดหมู่ใดๆ
      จะเป็นการตรวจสอบสินค้าทั้งร้าน
    </p>
    <p>
      ** กรณีเลือกอย่างใดอย่างหนึ่งเพียงกลุ่มเดียว
      จะเป็นการตรวจสอบสินค้าตามกลุ่มที่เลือก ซึ่งไม่ใช่ทั้งหมด
    </p>
    <p>** กรณีเลือกมากกว่าหนึ่งกลุ่ม จะเป็นการตรวจสอบแบบใช้เงื่อนไขร่วมกัน</p>
  </div>
</template>

<script>
export default {}
</script>

<style>
.warn-section {
  color: red;
  padding: 1rem 0;
  text-align: left;
}
</style>
